import React from 'react';
import { Button } from '../../../../components';
import { logIn, signIn } from '../../../../utils/operon';
import './style.scss';

const Header = () => {
	return (
		<section className="login-page__header header">
			<div className="header__text-content">
				<h2 className="header__heading">Generator Testów dla nauczycieli</h2>
				<h2 className="header__text">Szybki sposób na przygotowanie testów i sprawdzianów</h2>
			</div>
			<div className="header__login-box login-box">
				<h2 className="login-box__header">Zaloguj się i korzystaj z Generatora Testów</h2>
				<Button
					color="primary text-white"
					className="login-box__login-btn"
					fullWidth
					onClick={logIn}
				>
					Zaloguj się przez operon id
				</Button>
				<span className="login-box__signup-question">Nie masz konta?</span>
				<Button color="secondary text-white" className="login-box__signup-btn" onClick={signIn}>
					Zarejestruj się
				</Button>
			</div>
		</section>
	);
};

export default Header;
